import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from "@reduxjs/toolkit/query/react";
import { FETCH_BASE_URL } from "../constants/app.constants";
import { setUserAuthentication } from "../lib/store/slices/auth";
import { EQueryTagTypes } from "../types/api";
import { getCookie } from "./helpers";

const baseQuery = fetchBaseQuery({
  baseUrl: FETCH_BASE_URL,
  prepareHeaders(headers) {
    // here we set application/json as default for our BE framework
    // if no - for some responses e.g 404 we caould get json parse error from
    // rtk query because BE returns html
    if (!headers.has("Accept")) {
      headers.set("Accept", "application/json");
    }

    const token = getCookie("PHPSESSID");

    if (token) {
      headers.set("SessionId", token);
    }

    return headers;
  },
  // credentials: "include", // TODO 1. well delete when back fixes error
  // mode: "no-cors", // TODO 2. well delete when back fixes error, and "proxy": "http://localhost:8000" in package.json
});

const baseQueryWrapper: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const token = getCookie("PHPSESSID");

  if (token) {
    api.dispatch(setUserAuthentication(true));
  }

  const result = await baseQuery(args, api, extraOptions);
  if (result.error && result.error.status === 401) {
    api.dispatch(setUserAuthentication(false));
  }

  return result;
};

// const baseQueryWithReauth: BaseQueryFn<
//   string | FetchArgs,
//   unknown,
//   FetchBaseQueryError
// > = async (args, api, extraOptions) => {
//   const result = await baseQuery(args, api, extraOptions);
//   return result;
// };

const api = createApi({
  baseQuery: baseQueryWrapper,
  tagTypes: Object.values(EQueryTagTypes),
  reducerPath: "api",
  endpoints: () => ({}),
});

export default api;
